export const EDITOR_COMPONENT_INICIALIZADO = 'EDITOR_COMPONENT_INICIALIZADO';
export const editorInicializado = (editorInicializado) => ({
  type: EDITOR_COMPONENT_INICIALIZADO,
  payload: {
    editorInicializado,
  },
});
export const EDITOR_COMPONENT_ALTURA = 'EDITOR_COMPONENT_ALTURA';
export const editorAltura = (alturaEditor) => ({
  type: EDITOR_COMPONENT_ALTURA,
  payload: {
    alturaEditor,
  },
});
export const EDITOR_COMPONENT_LARGURA = 'EDITOR_COMPONENT_LARGURA';
export const editorLargura = (larguraEditor) => ({
  type: EDITOR_COMPONENT_LARGURA,
  payload: {
    larguraEditor,
  },
});

export const EDITOR_COMPONENT_CARREGADO = 'EDITOR_COMPONENT_CARREGADO';
export const editorCarregado = (editorCarregado) => ({
  type: EDITOR_COMPONENT_CARREGADO,
  payload: {
    editorCarregado,
  },
});

export const EDITOR_COMPONENT_TEXTO_INICIAL = 'EDITOR_COMPONENT_TEXTO_INICIAL';
export const textoInicial = (textoInicial) => ({
  type: EDITOR_COMPONENT_TEXTO_INICIAL,
  payload: {
    textoInicial,
  },
});
export const EDITOR_COMPONENT_SHOW_EDITOR = 'EDITOR_COMPONENT_SHOW_EDITOR';
export const showEditor = (showEditor) => ({
  type: EDITOR_COMPONENT_SHOW_EDITOR,
  payload: {
    showEditor,
  },
});

export const EDITOR_COMPONENT_AUTOSAVE = 'EDITOR_COMPONENT_AUTOSAVE';
export const autoSaveEditor = (autoSaveEditor) => ({
  type: EDITOR_COMPONENT_AUTOSAVE,
  payload: {
    autoSaveEditor,
  },
});

//OLD

export const DADOS_EDITOR_COMPONENT_RTF = 'DADOS_EDITOR_COMPONENT_RTF';
export const editorRtf = (textRtf) => ({
  type: DADOS_EDITOR_COMPONENT_RTF,
  payload: {
    textRtf,
  },
});

export const ID_RTF_EDITOR_COMPONENT = 'ID_RTF_EDITOR_COMPONENT';
export const idRtf = (idRtf) => ({
  type: ID_RTF_EDITOR_COMPONENT,
  payload: {
    idRtf,
  },
});

export const DADOS_EDITOR_COMPONENT_PLAIN_TEXT = 'DADOS_EDITOR_COMPONENT_PLAIN_TEXT';
export const editorPlainText = (plainText) => ({
  type: DADOS_EDITOR_COMPONENT_PLAIN_TEXT,
  payload: {
    plainText,
  },
});

export const EDITOR_COMPONENT_READONLY = 'EDITOR_COMPONENT_READONLY';
export const editorReadOnly = (ReadOnly) => ({
  type: EDITOR_COMPONENT_READONLY,
  payload: {
    editorReadOnly: ReadOnly,
  },
});

export const EDITOR_COMPONENT_CHANGE_STATUS = 'EDITOR_COMPONENT_CHANGE_STATUS';
export const ChangeStatus = (status) => ({
  type: EDITOR_COMPONENT_CHANGE_STATUS,
  payload: {
    status,
  },
});

export const EDITOR_COMPONENT_ATUALIZAR_AVISO = 'EDITOR_COMPONENT_ATUALIZAR_AVISO';
export const atualizarAviso = (mensagem, tipo) => ({
  type: EDITOR_COMPONENT_ATUALIZAR_AVISO,
  payload: {
    mensagem,
    tipo,
  },
});



// WEBPACK FOOTER //
// ./src/componentes/editor/editor.action.js